import { gql } from 'apollo-angular';

export const Query_GetEquipmentCountingJournalMetrics = gql`
  query getEquipmentCountingJournalMetrics(
    $filter: DtoEquipmentCountingJournalMetricsFilter
  ) {
    getEquipmentCountingJournalMetrics(filter: $filter) {
      totalJournals
      totalLines
      completedJournals
      inProgressJournals
      readyJournals
      recountJournals
      cancelledJournals
      countedLines
      waitingCountLines
      notFoundLines
      addedLines
      otherLocationLines
      completionRate
      varianceRate
      accuracyRate
      incorrectLocationRate
      incorrectLocationCount
      incorrectStationRate
      incorrectStationCount
      missingRate
      missingCount
      missingBookValue
      estimatedReplacementCost
      missingAvgAge
    }
  }
`;
